import { UserModel } from "../Models/user.mode";
import { NotificationResponse } from "../Models/user.mode";
import request, { Method } from "../request";

interface userTokenResponse {
    user: UserModel;
    token: string;
    endpoint: string;
    isFirstLogin?: string;
}

class UserService {
    async login(email: string, password: string): Promise<userTokenResponse> {
        return request<userTokenResponse>(`/auth/login`, Method.POST, {
            data: {
                email: email,
                password: password,
                appId: 't_patroller',
                newApp: '1'
            },
        });
    }

    async resetPassword(password: string): Promise<any> {
        return request<userTokenResponse>(`/auth/reset-password`, Method.POST, {
            data: {
                password: password,
            },
        });
    }

    async getCurrentUser() {
        return request<userTokenResponse>(`/auth/current-user`, Method.GET);
    }

    async logout() {
        return request(`/auth/logout`, Method.POST);
    }

    async getCookies() {
        return request(`/sanctum/csrf-cookie`, Method.GET, {}, false);
    }

    async notifications(lastFetchTime: string | null): Promise<NotificationResponse> {
        return request<NotificationResponse>(`/auth/notifications`, Method.POST, {
            lastFetchTime: lastFetchTime || null,
        });
    }

    async readNotification() {
        return request(`/auth/notification_read`, Method.GET);
    }

    async deleteNotification(id: number) {
        return request(`/auth/notification/${id}/delete`, Method.GET);
    }

}

export const userService = new UserService();
